import { render, staticRenderFns } from "./folders-vessels-option-charterers.vue?vue&type=template&id=1a2e504a&scoped=true"
import script from "./folders-vessels-option-charterers.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option-charterers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e504a",
  null
  
)

export default component.exports